export const DEFAULT_SITE_CONTENT = {
  seo: {
    home: {
      title: "Сверхум — ИИ-помощник педагога",
      description:
        "Сверхум помогает педагогам готовить материалы, сценарии, аттестационные тексты, контент для госпабликов и визуалы быстрее.",
      ogTitle: "Сверхум — ИИ-помощник педагога",
      ogDescription:
        "Материалы, сценарии, аттестация, оформление и контент для педагогов в одном ИИ-помощнике.",
      ogImage: "/logo.png",
      canonicalUrl: ""
    },
    payment: {
      title: "Оплата Сверхум — выберите тариф для педагога",
      description:
        "Выберите подходящий тариф Сверхум, оплатите удобным способом и получите доступ к ИИ-инструментам для педагогических задач.",
      ogTitle: "Тарифы Сверхум",
      ogDescription:
        "Подписки Сверхум для педагогов: тарифы, периоды и безопасная оплата через YooKassa.",
      ogImage: "/logo.png",
      canonicalUrl: ""
    }
  },
  home: {
    hero: {
      eyebrow: "Сверхум для педагогов",
      title: "ИИ-помощник, который экономит часы методической работы",
      subtitle:
        "Готовьте сценарии, аттестационные материалы, посты для госпаблика, конспекты и визуалы в одном боте без перегруженных сервисов и десятка вкладок.",
      primaryLabel: "Открыть бота VK",
      primaryUrl: "https://vk.com/newchatgpt",
      secondaryLabel: "Перейти к тарифам",
      secondaryUrl: "/payment",
      footnote:
        "Подходит для ДОУ, СОШ, методистов, классных руководителей и администраторов образовательных проектов.",
      badges: ["Аттестация и отчёты", "Сценарии и конспекты", "Госпаблики и оформление"]
    },
    features: [
      {
        title: "Материалы без рутины",
        description: "Сверхум помогает быстро подготовить тексты, идеи, документы и черновики для ежедневной работы педагога."
      },
      {
        title: "Сценарии и занятия",
        description: "Утренники, открытые занятия, дидактические игры, КТП и другие форматы собираются в понятную структуру за минуты."
      },
      {
        title: "Контент и визуалы",
        description: "Посты для госпабликов, афиши, иллюстрации и ИИ-фотосессии оформляются в одном рабочем процессе."
      }
    ],
    useCases: [
      {
        title: "Для аттестации и отчётов",
        description: "Переработка материалов в официальный формат, помощь с самоанализом, портфолио и методическими описаниями."
      },
      {
        title: "Для занятий и мероприятий",
        description: "Сценарии праздников, конспекты, игры, планы уроков и идеи активностей под возраст и задачу."
      },
      {
        title: "Для госпабликов и сообщества",
        description: "Посты, анонсы, афиши и тексты для образовательных пабликов без пустого канцелярита."
      },
      {
        title: "Для визуального оформления",
        description: "Иллюстрации, материалы для печати, фотосессии и визуалы, которые поддерживают образовательные задачи."
      }
    ],
    steps: [
      {
        title: "Откройте бота",
        description: "Запустите Сверхум, выберите направление работы и напишите задачу обычным языком."
      },
      {
        title: "Получите заготовку",
        description: "Бот предложит готовый текст, структуру, сценарий или визуальную идею под ваш запрос."
      },
      {
        title: "Доработайте под себя",
        description: "Уточните возраст, формат, тон или требования и доведите результат до рабочего финала."
      }
    ],
    faq: [
      {
        question: "Для кого подходит Сверхум?",
        answer: "Для воспитателей ДОУ, учителей, методистов, классных руководителей и тех, кто готовит образовательный контент."
      },
      {
        question: "Можно ли использовать Сверхум для аттестации?",
        answer: "Да, сервис помогает оформить материалы в более официальный и структурированный формат для отчётов, портфолио и самоанализа."
      },
      {
        question: "Что входит в платные тарифы?",
        answer: "Платные тарифы открывают больше лимитов, дополнительные инструменты и удобный рабочий запас ресурсов для постоянной работы."
      }
    ],
    cta: {
      title: "Подключите Сверхум к своей рабочей рутине",
      text: "Откройте бота, попробуйте сценарии, материалы и оформление на реальных задачах, а затем выберите подходящий тариф.",
      primaryLabel: "Запустить в VK",
      primaryUrl: "https://vk.com/newchatgpt",
      secondaryLabel: "Посмотреть оплату",
      secondaryUrl: "/payment"
    },
    contacts: {
      title: "Контакты и ссылки",
      text: "Если нужна помощь с оплатой или запуском, используйте основные рабочие каналы ниже.",
      items: [
        { label: "Бот VK", value: "vk.com/newchatgpt", url: "https://vk.com/newchatgpt" },
        { label: "Сообщество", value: "@pedagogai", url: "https://vk.com/pedagogai" },
        { label: "Оплата", value: "pay.sverhum.ru", url: "https://pay.sverhum.ru/payment" }
      ]
    }
  },
  payment: {
    headline: "Выберите тариф Сверхум",
    subheadline:
      "Тарифы и периоды подтягиваются из рабочего каталога бота, поэтому на сайте всегда актуальная структура оплаты.",
    helpText:
      "Укажите ваш VK ID или ссылку на профиль, выберите тариф и способ оплаты. После оплаты доступ активируется на стороне бота.",
    note:
      "Если платёж не отразился сразу, проверьте, что вы указали корректный профиль, и свяжитесь с поддержкой.",
    agreementUrl: "https://vk.com/@pedagogai-intellekt-pedagoga-pervaya-neiroset-dlya-spo-mbdou",
    cancelUrl: "https://vk.com/gptfather",
    contacts: [
      { label: "Поддержка", value: "@qwizyop", url: "https://t.me/qwizyop" },
      { label: "Email", value: "easybej1ukuu@gmail.com", url: "mailto:easybej1ukuu@gmail.com" },
      { label: "ИНН", value: "226702366647", url: "" }
    ],
    successLinks: [
      { label: "Вернуться в бот VK", value: "", url: "https://vk.com/newchatgpt" },
      { label: "Открыть главную", value: "", url: "/" }
    ]
  },
  updatedAt: null
};
